<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-08 17:30:25
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-08 17:30:25
-->
<template>
  <div>
    <p class="fz-14 yx-text-color-regular">货盘联系人: {{row.contact_name}}</p>
    <p class="fz-14 yx-text-color-regular">手机号码: {{row.contact_mobile}}</p>
    <p class="fz-14 yx-text-color-regular">微信号: {{row.contact_wechat}}</p>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin]
}
</script>